import { Radio } from 'antd';
import { CustomImage } from '@src/components';
import '@src/styles/cardOrder/creditCards.scss';
import { bankCodeIcon, cardTypeIcon } from '@src/utils/utils';

const CreditCards = ({ cardItem }) => {
  const bankIcon = bankCodeIcon(cardItem?.bankCode);
  const cardIcon = cardTypeIcon(cardItem?.cardType);

  return (
    <Radio id={`ticketRestaurant-cardOrders-payment-creditCards-${cardItem?.cardToken}`} value={cardItem?.cardToken} key={cardItem?.id}>
      <div className="credit-card-item">
        <CustomImage className="bank-card-logo" src={bankIcon} />
        <div className="card-number">{cardItem?.maskedCardNumber}</div>
        <div className="card-info">
          <CustomImage className="card-type-logo" src={cardIcon} />
        </div>
      </div>
    </Radio>
  );
};

export default CreditCards;
